import { render } from "./LocaleDropdown.vue?vue&type=template&id=3020e1a2&scoped=true"
import script from "./LocaleDropdown.vue?vue&type=script&lang=js"
export * from "./LocaleDropdown.vue?vue&type=script&lang=js"

import "./LocaleDropdown.vue?vue&type=style&index=0&id=3020e1a2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3020e1a2"]])

export default __exports__